import { GameUI } from "game/gameUI/GameUI";
import { translate } from "game/translate"
import { Popups } from "ui/types/popups";

export const TutorialStartPopup = () => {
    const handleCloseBtnClick = () => {
        GameUI.closePopup(Popups.TUTORIAL_START);
    }

    const handleDiscardBtnClick = () => {
        GameUI.closePopup(Popups.TUTORIAL_START);
        document.dispatchEvent(new CustomEvent('closeModal', { detail: { id: 'tutorial_start', confirm: false, button: document.querySelector('.discard_btn') } }));
    }

    const handleStartBtnClick = () => {
        GameUI.closePopup(Popups.TUTORIAL_START, true);
        document.dispatchEvent(new CustomEvent('closeModal', { detail: { id: 'tutorial_start', confirm: true } }));
    }
    
    return (
        <div id="tutorial_start" role="tooltip" className="tutorial_start modals_area active">
            <div className="wrapper">
                <div className="text_content">
                    <button type="button" className="close_btn close" onClick={handleCloseBtnClick}></button>
                    <span className="modals_area-title">{translate("tutorial_start_title")}</span>
                    <img loading="lazy" className="modals_area_img" src="/assets/tutorial/tutorial_start.webp" />
                    <p className="modals_area-text">{translate("tutorial_start_text")}</p>
                    <div className="feedback_btn-wrap">
                        <button type="button" className="discard_btn close" onClick={handleDiscardBtnClick}>{translate("tutorial_start_button_1")}</button>
                        <button type="button" className="modals_area-btn" onClick={handleStartBtnClick}>{translate("tutorial_start_button_2")}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}




